import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Common = ({ router }) => {
  const { t } = useTranslation('common')

  return (
    <ul className='header-links__list'>
      <li>
        <a href={'https://play.google.com/store/apps/details?id=me.autodiler'} target='blank'>
          <i className={'ico-top-meni-google-play ico'} />
          &nbsp;
          Google Play
        </a>
      </li>

      <li>
        <a href={'https://apps.apple.com/us/app/autodiler/id844615689'} target='blank'>
          <i className={'ico-top-meni-apple-store ico'} />
          &nbsp;
          Apple Store
        </a>
      </li>

      <li>
        <a href={'https://appgallery.huawei.com/app/C102884519'} target='blank'>
          <img src={'/icons/huawei-appgallery.svg'} alt='icon' width={18} style={{ height: 21 }} />
          &nbsp;
          AppGallery
        </a>
      </li>

      <li className={router && router.pathname === '/marketing' ? 'active' : ''}>
        <a href={'/marketing'} target='blank'>
          <img src={'/icons/marketing.svg'} alt='icon' width={18} style={{ height: 21 }} />
          &nbsp;
          {t('Marketing')}
        </a>
      </li>

      <li className={router && router.pathname === '/kontakt' ? 'active' : ''}>
        <a href={'/kontakt'}>
          <i className={'ico-top-meni-kontakt ico'} />
          &nbsp;
          {t('Kontakt')}
        </a>
      </li>
    </ul>
  )
}

Common.propTypes = {
  router: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  })
}
